import { Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSitesSelected, useTreeContext } from '../../TreeProvider'
import {
  StyledToolbar,
  StyledContainer,
  StyledTabsArea,
  StyledTabs,
  StyledTab,
  StyledTabContent,
  StyledTabLabel,
  StyledCountChip,
  StyledActionButton,
  StyledIcon
} from './TopBar.styles'

const TopBar = ({
  activeTab = 0,
  onTabChange = () => {},
  showSearch = false
}) => {
  const { t } = useTranslation()
  const { onNodeRemoveAll, selection, isFolded, onFoldedToggle, accounts } = useTreeContext()
  const { count: numberOfSitesSelected } = useSitesSelected({ selection })
  const totalChildSites = accounts?.filter(account => account.is_site)?.length || 0
  const selectedTabIsEmpty = numberOfSitesSelected === 0

  const renderTabLabel = (label, count, active, empty = false) => (
    <StyledTabContent direction="row" gap={0.75} alignItems="center">
      <StyledTabLabel empty={empty ? 1 : 0}>{label}</StyledTabLabel>
      <StyledCountChip active={active ? 1 : 0} empty={empty ? 1 : 0}>
        {count}
      </StyledCountChip>
    </StyledTabContent>
  )

  const renderActions = (compact = false) => (
    <Stack
      gap={compact ? 1 : 2}
      direction="row"
      alignItems="center"
      sx={compact ? { height: 32, flex: '0 0 auto', alignSelf: 'stretch' } : undefined}
    >
      {compact ? (
        <>
          <StyledActionButton disableRipple onClick={onNodeRemoveAll}>
            <i className="fa-regular fa-arrows-rotate-reverse" />
          </StyledActionButton>
          <StyledActionButton disableRipple onClick={onFoldedToggle}>
            <i className={`fa-regular ${isFolded ? 'fa-arrows-from-line' : 'fa-arrows-to-line'}`} />
          </StyledActionButton>
        </>
      ) : (
        <>
          <StyledIcon className="fa-regular fa-arrows-rotate" onClick={onNodeRemoveAll} />
          <StyledIcon
            className={`fa-light ${isFolded ? 'fa-arrows-from-line' : 'fa-arrows-to-line'}`}
            onClick={onFoldedToggle}
          />
        </>
      )}
    </Stack>
  )

  return (
    <StyledToolbar>
      <StyledContainer direction="row" justifyContent="space-between">
        <StyledTabsArea direction="row" alignItems="center">
          <StyledTabs value={activeTab} onChange={(_, value) => onTabChange(value)}>
            <StyledTab
              disableRipple
              label={renderTabLabel(t('master_filter.all_sites', t('master_filter.all')), totalChildSites, activeTab === 0)}
            />
            <StyledTab
              disableRipple
              disabled={selectedTabIsEmpty}
              empty={selectedTabIsEmpty ? 1 : 0}
              label={renderTabLabel(
                t('master_filter.selected_sites'),
                numberOfSitesSelected,
                activeTab === 1,
                selectedTabIsEmpty
              )}
            />
          </StyledTabs>
          {showSearch && renderActions(true)}
        </StyledTabsArea>

        {!showSearch && renderActions()}
      </StyledContainer>
    </StyledToolbar>
  )
}

export default TopBar
